// extracted by mini-css-extract-plugin
export var fullHeightState = "_56-7";
export var headerCell = "_56-1";
export var loadingStateCell = "_56-4";
export var rowWrapper = "_56-3";
export var standaloneTable = "_56-8";
export var standaloneTableWithBodyFill = "_56-9";
export var stateCell = "_56-5";
export var table = "_56-0";
export var tableBodyFiller = "_56-6";
export var white = "_56-2";